// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"f0a22e96","703":"c9a936ef","787":"ab9771c8"}[chunkId] + ".chunk.js";
};